import { inject, Injectable } from '@angular/core';
import { networkActions } from './network-actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap, filter, map, distinctUntilChanged } from 'rxjs';
import { Dialog } from '@angular/cdk/dialog';
import { PwaService } from 'src/app/core/services/pwa/pwa.service';
import { appActions } from '../app/app-actions';
import { AlertService } from 'src/app/features/bizzmine/alerts/alert.service';


@Injectable()
export class NetworkEffects {
  private actions$ = inject(Actions);
  private dialog = inject(Dialog);
  private pwaService = inject(PwaService);
  private alertService = inject(AlertService);
  
   public networkStatusOffline$ = createEffect(() => this.actions$.pipe(
    ofType(networkActions.statusChanged),
    filter((action) => action.isOnline === false), // Only react to going offline
    tap(() => {
      this.pwaService.setMaxOfflinePwaUsage();
    })
  ), {dispatch: false});

}
